import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import organizerRepository from 'modules/organizer/domain/repositories/organizer-repository';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

export function useFetchActivePlan() {
  const userTournamentId = useSelector(authStoreUserTournamentId);

  return useQuery({
    queryKey: ['activePlan', userTournamentId],
    queryFn: () => {
      if (!userTournamentId) return Promise.resolve(null);
      return organizerRepository.fetchActivePaidSubscription(userTournamentId);
    },
    enabled: !!userTournamentId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
